var map = {
	".": [
		17995,
		9
	],
	"./": [
		17995,
		9
	],
	"./DefaultLeaderbaord.scss": [
		91486,
		7,
		486
	],
	"./DefaultLeaderboard": [
		81537,
		9
	],
	"./DefaultLeaderboard.jsx": [
		81537,
		9
	],
	"./DynamicSprite": [
		87781,
		9
	],
	"./DynamicSprite.jsx": [
		87781,
		9
	],
	"./index": [
		17995,
		9
	],
	"./index.js": [
		17995,
		9
	],
	"./sprites/spring_2025/Char0Var0": [
		39801,
		9,
		801
	],
	"./sprites/spring_2025/Char0Var0.jsx": [
		39801,
		9,
		801
	],
	"./sprites/spring_2025/Char0Var0.scss": [
		75030,
		7,
		30
	],
	"./sprites/spring_2025/Char0Var1": [
		89044,
		9,
		44
	],
	"./sprites/spring_2025/Char0Var1.jsx": [
		89044,
		9,
		44
	],
	"./sprites/spring_2025/Char0Var1.scss": [
		50757,
		7,
		757
	],
	"./sprites/spring_2025/Char0Var2": [
		86015,
		9,
		15
	],
	"./sprites/spring_2025/Char0Var2.jsx": [
		86015,
		9,
		15
	],
	"./sprites/spring_2025/Char0Var2.scss": [
		93088,
		7,
		88
	],
	"./sprites/spring_2025/Char1Var0": [
		42268,
		9,
		268
	],
	"./sprites/spring_2025/Char1Var0.jsx": [
		42268,
		9,
		268
	],
	"./sprites/spring_2025/Char1Var0.scss": [
		54269,
		7,
		269
	],
	"./sprites/spring_2025/Char1Var1": [
		21985,
		9,
		985
	],
	"./sprites/spring_2025/Char1Var1.jsx": [
		21985,
		9,
		985
	],
	"./sprites/spring_2025/Char1Var1.scss": [
		48814,
		7,
		814
	],
	"./sprites/spring_2025/Char1Var2": [
		73946,
		9,
		946
	],
	"./sprites/spring_2025/Char1Var2.jsx": [
		73946,
		9,
		946
	],
	"./sprites/spring_2025/Char1Var2.scss": [
		63687,
		7,
		687
	],
	"components/games/elements/GenericGame/DefaultLeaderboard": [
		17995,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/": [
		17995,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DefaultLeaderbaord.scss": [
		91486,
		7,
		486
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DefaultLeaderboard": [
		81537,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DefaultLeaderboard.jsx": [
		81537,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DynamicSprite": [
		87781,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DynamicSprite.jsx": [
		87781,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/index": [
		17995,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/index.js": [
		17995,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var0": [
		39801,
		9,
		801
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var0.jsx": [
		39801,
		9,
		801
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var0.scss": [
		75030,
		7,
		30
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var1": [
		89044,
		9,
		44
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var1.jsx": [
		89044,
		9,
		44
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var1.scss": [
		50757,
		7,
		757
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var2": [
		86015,
		9,
		15
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var2.jsx": [
		86015,
		9,
		15
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var2.scss": [
		93088,
		7,
		88
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var0": [
		42268,
		9,
		268
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var0.jsx": [
		42268,
		9,
		268
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var0.scss": [
		54269,
		7,
		269
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var1": [
		21985,
		9,
		985
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var1.jsx": [
		21985,
		9,
		985
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var1.scss": [
		48814,
		7,
		814
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var2": [
		73946,
		9,
		946
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var2.jsx": [
		73946,
		9,
		946
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var2.scss": [
		63687,
		7,
		687
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68411;
module.exports = webpackAsyncContext;